jQuery(document).ready(function($) {
    $("#scroll_down").click(function() {
        $('html,body').animate({
                scrollTop: $("#scrollTo").offset().top},
            'fast');
    });
});
//# sourceMappingURL=scroll-down.js.map
